<app-card-shadow class="w-fit gap-y-2" *ngIf="!showExtraInfoForm">
    <h1 class="mb-2">Pagar ahora</h1>
    <p class="text-xs text-lightGray mb-1">Si lo deseas, puedes adelantar el pago de tu cita telemáticamente.</p>
    <div class="flex flex-row justify-center gap-2 w-full text-sm mt-2">
      <button appNextSquare class="text-sm" (click)="toggleShowExtraInfoForm()">Pago online</button>
      <button appNextSquare class="text-sm" (click)="toggleShowExtraInfoForm()">Imprimir para pagar en banco</button>
    </div>
</app-card-shadow>
<app-card-shadow class="w-fit gap-y-2" *ngIf="showExtraInfoForm">
    <h2 class="text-xl my-6">Necesitamos los últimos datos para el pago</h2>
    <form [formGroup]="extraInfoForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-col mb-4">
        <label>Email:</label>
        <input appFormInput type="email" formControlName="email" />
        <div *ngIf="extraInfoForm.get('email')?.invalid && extraInfoForm.get('email')?.touched">
          <small class="text-red2" *ngIf="extraInfoForm.get('email')?.hasError('required')">El email es obligatorio.</small>
          <small class="text-red2" *ngIf="extraInfoForm.get('email')?.hasError('email')">Debe ser un email válido.</small>
        </div>
      </div>

      <div *ngIf="existingReservation.vehicle_id == 1 || existingReservation.vehicle_id == 8" class="flex flex-col my-4">
        <label>Tipo de vehículo:</label>
        <select appFormSelectSquare formControlName="lightweight_vehicle">
          <option value="" disabled selected>Seleccione uno</option>
          <option [value]="0">Turismo / Cuadriciclos / Quad</option>
          <option [value]="1">Furgoneta</option>
        </select>
        <div *ngIf="extraInfoForm.get('lightweight_vehicle')?.invalid && extraInfoForm.get('lightweight_vehicle')?.touched">
          <small class="text-red2" *ngIf="extraInfoForm.get('lightweight_vehicle')?.hasError('required')">El tipo de vehículo es obligatorio.</small>
        </div>
      </div>

      <div *ngIf="existingReservation.vehicle_id == 1 || existingReservation.vehicle_id == 8" class="flex flex-col my-4">
        <label>Fecha de matriculación:</label>
        <select appFormSelectSquare formControlName="heavy_vehicle_over">
          <option value="" disabled selected>Seleccione uno</option>
          <option [value]="0">Anterior a 01/01/1980</option>
          <option [value]="1">A partir del 01/01/1980</option>
        </select>
        <div *ngIf="extraInfoForm.get('heavy_vehicle_over')?.invalid && extraInfoForm.get('heavy_vehicle_over')?.touched">
          <small class="text-red2" *ngIf="extraInfoForm.get('heavy_vehicle_over')?.hasError('required')">Fecha de matriculación es obligatorio.</small>
        </div>
      </div>

      <div *ngIf="existingReservation.service_id === 2 && extraInfoForm.get('heavy_vehicle_over')?.value == 1" class="flex flex-col my-4">
        <label for="second_inspection" class="mb-1">Problema en inspección:</label>
        <select
          formControlName="second_inspection"
          appFormSelectSquare
        >
          <option value="" disabled>Seleccione uno</option>
          <option [value]="SecondInspection.Contaminacion">Contaminación</option>
          <option [value]="SecondInspection.Seguridad">Seguridad</option>
          <option [value]="SecondInspection.Ambos">Ambos</option>
        </select>
      </div>
      
      <div *ngIf="existingReservation.vehicle_id == 4 ||
       existingReservation.vehicle_id == 6 || 
       existingReservation.vehicle_id == 9 || 
       existingReservation.vehicle_id == 10" class="flex flex-col my-4">
        <label>Tipo de vehículo pesado:</label>
        <select appFormSelectSquare formControlName="heavy_vehicle_over">
          <option value="" disabled selected>Seleccione uno</option>
          <option [value]="0">Anterior a 01/01/1980</option>
          <option [value]="1">A partir del 01/01/1980</option>
        </select>
        <div *ngIf="extraInfoForm.get('heavy_vehicle_over')?.invalid && extraInfoForm.get('heavy_vehicle_over')?.touched">
          <small class="text-red2" *ngIf="extraInfoForm.get('heavy_vehicle_over')?.hasError('required')">El tipo de vehículo es obligatorio.</small>
        </div>
      </div>

      <div *ngIf="existingReservation.fuel_id == 3" class="flex flex-col my-4">
        <label>Tipo de híbrido:</label>
        <select appFormSelectSquare formControlName="diesel">
          <option value="" disabled selected>Seleccione uno</option>
          <option [value]="0">Híbrido gasolina</option>
          <option [value]="1">Híbrido diesel</option>
        </select>
        <div *ngIf="extraInfoForm.get('diesel')?.invalid && extraInfoForm.get('diesel')?.touched">
          <small class="text-red2" *ngIf="extraInfoForm.get('diesel')?.hasError('required')">El tipo de vehículo es obligatorio.</small>
        </div>
      </div>

      <div *ngIf="existingReservation.vehicle_id == 7" class="flex flex-col">
        <label>Tipo de vehículo agricola:</label>
        <select appFormSelectSquare formControlName="farm_type">
          <option value="" disabled selected>Seleccione uno</option>
          <option value="tractor">Tractor</option>
          <option value="trailer">Remolque</option>
        </select>
        <div *ngIf="extraInfoForm.get('farm_type')?.invalid && extraInfoForm.get('farm_type')?.touched">
          <small class="text-red2" *ngIf="extraInfoForm.get('farm_type')?.hasError('required')">El tipo de vehículo es obligatorio.</small>
        </div>
      </div>

      <div class="flex justify-center">
        <button appNextButton class="my-6 text-sm" type="submit" [disabled]="extraInfoForm.invalid">Pagar</button>
      </div>
    </form>
</app-card-shadow>